// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__27zPk","inputWrap":"styles_inputWrap__1aN2W","input":"styles_input__206N9"};